var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiceBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2998",
    "data-name": "Group 2998",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.74,
    height: 53.327,
    viewBox: "0 0 57.74 53.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11222",
    "data-name": "Rectangle 11222",
    width: 57.74,
    height: 53.327,
    fill: "#22294b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2997",
    "data-name": "Group 2997",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3451",
    "data-name": "Path 3451",
    d: "M54.2,36.959H3.248a3.9,3.9,0,0,1,0-7.794H54.2a3.9,3.9,0,0,1,0,7.794ZM3.248,31.493a1.57,1.57,0,0,0,0,3.139H54.2a1.57,1.57,0,0,0,0-3.139Z",
    transform: "translate(0.145 -6.542)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3452",
    "data-name": "Path 3452",
    d: "M41.816,58.09H16.57a1.164,1.164,0,0,1-.392-.068A20.739,20.739,0,0,1,7.87,52.59a23.225,23.225,0,0,1-4.393-6.946,26.928,26.928,0,0,1-2.034-8.533,1.164,1.164,0,1,1,2.326-.083,25.07,25.07,0,0,0,1.888,7.794,18.861,18.861,0,0,0,11.12,10.94H41.612a18.873,18.873,0,0,0,11.15-11.012,24.844,24.844,0,0,0,1.858-7.723,1.164,1.164,0,1,1,2.326.083,26.928,26.928,0,0,1-2.034,8.533,23.225,23.225,0,0,1-4.393,6.946,20.739,20.739,0,0,1-8.309,5.432A1.164,1.164,0,0,1,41.816,58.09Z",
    transform: "translate(-0.323 -8.054)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3453",
    "data-name": "Path 3453",
    d: "M41.816,58.09H16.57a1.164,1.164,0,0,1-.392-.068A20.739,20.739,0,0,1,7.87,52.59a23.225,23.225,0,0,1-4.393-6.946,26.928,26.928,0,0,1-2.034-8.533,1.164,1.164,0,1,1,2.326-.083,25.07,25.07,0,0,0,1.888,7.794,18.861,18.861,0,0,0,11.12,10.94H41.612a18.873,18.873,0,0,0,11.15-11.012,24.844,24.844,0,0,0,1.858-7.723,1.164,1.164,0,1,1,2.326.083,26.928,26.928,0,0,1-2.034,8.533,23.225,23.225,0,0,1-4.393,6.946,20.739,20.739,0,0,1-8.309,5.432A1.164,1.164,0,0,1,41.816,58.09Z",
    transform: "translate(-0.323 -8.054)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3454",
    "data-name": "Path 3454",
    d: "M43.184,67.828H23.167a3.987,3.987,0,0,1-3.241-1.672,3.871,3.871,0,0,1-.516-3.55c.036-.1.065-.174.076-.2l2.135.926.005-.012s-.006.015-.016.043a1.571,1.571,0,0,0,.212,1.442,1.634,1.634,0,0,0,1.345.695H43.184a1.634,1.634,0,0,0,1.345-.695,1.57,1.57,0,0,0,.214-1.436c-.011-.031-.019-.051-.022-.059l0,.006,2.149-.892c.007.016.032.077.066.173l0,.008a3.871,3.871,0,0,1-.516,3.55A3.987,3.987,0,0,1,43.184,67.828Z",
    transform: "translate(-4.305 -13.998)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3455",
    "data-name": "Path 3455",
    d: "M54.565,27.065A1.164,1.164,0,0,1,53.4,25.9a5.8,5.8,0,0,0-6.608-5.793,1.163,1.163,0,0,1-1.3-.949,5.839,5.839,0,0,0-8.964-3.849,1.163,1.163,0,0,1-1.67-.429,5.844,5.844,0,0,0-10.351,0,1.163,1.163,0,0,1-1.67.429,5.84,5.84,0,0,0-8.965,3.849,1.164,1.164,0,0,1-1.3.949A5.8,5.8,0,0,0,5.976,25.9a1.164,1.164,0,1,1-2.327,0,8.186,8.186,0,0,1,8.176-8.177h.014a8.169,8.169,0,0,1,11.245-4.941,8.17,8.17,0,0,1,13.208,0,8.169,8.169,0,0,1,11.245,4.941h.015A8.185,8.185,0,0,1,55.728,25.9,1.164,1.164,0,0,1,54.565,27.065Z",
    transform: "translate(-0.819 -2.114)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3456",
    "data-name": "Path 3456",
    d: "M58.122,17.859a1.164,1.164,0,0,1-.921-1.874L66.977,3.3a1.051,1.051,0,0,0-.3-1.454,1.077,1.077,0,0,0-1.5.371l-.018.026L56.92,13.473A1.164,1.164,0,1,1,55.043,12.1L63.273.88A3.546,3.546,0,0,1,65.391-.566,3.3,3.3,0,0,1,67.95-.1a3.378,3.378,0,0,1,.928,4.742l-.036.05-9.8,12.711A1.162,1.162,0,0,1,58.122,17.859Z",
    transform: "translate(-12.297 0.145)",
    fill: "#22294b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiceBl);
export default __webpack_public_path__ + "static/media/Rice-bl.a9dcc975db814f443de585379491ccd8.svg";
export { ForwardRef as ReactComponent };